import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import moment from "moment";
import Heading from "../../AdminPanel/Component/UI/Heading";
import AssessmentCard from "./Component/AssessmentCodeCard";
import ProgressTab from "../Component/ProgressTab";
import UploadCodeModal from "./Modal/UploadCodeModal";

class OverviewNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crrTeamId: "",
      currentStep: 1,
      openCodeModal: false
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAssessmentProducts());
    this.props.dispatch(assessmentActions.getAvailableCodeCount());
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  handleViewAllCodes = (item) => {
    this.props.history.push("/assessment/mycodes/" + item.id);
  };


  gotoProducts = () => {
    this.props.history.push(`/assessment/products`);
  };


  handleCodeModal = () => {
    this.setState({ openCodeModal: true })
  };
  handleOnClose = () => {
    this.setState({ openCodeModal: false })
  };

  gotoPageNo = (pageNo) => {
    if (pageNo === 1) {
      this.history.push("/assessment/overview");
    } else if (pageNo === 2) {
      this.history.push("/assessment/myusers");
    } else if (pageNo === 3) {
      this.history.push("/assessment/myteams");
    } else if (pageNo === 4) {
      this.history.push("/assessment/myresults");
    }
  };

  onCodeSubmit = (codeList) => {
    if (codeList && codeList.length > 0) {
      this.props.dispatch(
        assessmentActions.saveNewCodeList(codeList)
      );
      this.setState({ openCodeModal: false })
    }
  };


  render() {
    const { openCodeModal } = this.state;
    const { assessment } = this.props;
    const { userAssessmentUserProfileData, getAssessmentProductsData: productList = [], getAvailableCodeCountData: codeCountList = [] } = assessment;

    const getPeriod = () => {
      const hour = moment().hour();
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod(),
    };

    let { loading } = assessment;


    function getCodeCount(codeCountList = [], productId) {
      let count = codeCountList
        .filter(item => item.productId?.toString() === productId?.toString())
        .reduce((sum, item) => sum + (item.ordersCount || 0), 0);
      return count > 0 ? count : 0
    }

    const cardList = productList && productList.length > 0 ? productList.map((ele) => ({
      id: ele.id,
      code: ele.code,
      title: ele.name,
      description: "To understand all themes and identify your strengths, take the assessment TalentPlusStrengths 28.",
      imageUrl: "/img/Home/assessment_surveyv2.png",
      count: getCodeCount(codeCountList, ele.id)
    })) : [];

    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="w-full mx-auto min-h-screen flex flex-col justify-between p-8">
          <div className="">
            <ProgressTab currentStep={1} history={this.props.history} />
            <div className="border-b border-slate-300" />

            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4">
              <div>
                <Heading className="text-2xl font-bold text-gray-900" title="Assessment Code" />
                <p className="mt-1 text-sm text-gray-500">
                  Manage and monitor AI-driven competency surveys across your organization.
                </p>
              </div>
              <button onClick={() => this.handleCodeModal()} className="px-5 py-2 rounded-md bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-100">Get Assessment Code</button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10 pt-4">
              {cardList.map((item) => (
                <AssessmentCard
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  count={item.count}
                  imageUrl={item.imageUrl}
                  onViewAll={() => this.handleViewAllCodes(item)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="sticky bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-gray-200 py-4 px-6 flex items-center justify-between z-10">
          <div />
          {/* <button onClick={() => this.props.history.goBack()} className="px-8 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-500 font-semibold text-base transition-colors duration-200">  Back</button> */}
          <button onClick={() => this.props.history.push("/assessment/myusers")} className="px-5 py-2 rounded-md bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-100">  Continue to Step 2</button>
        </div>

        {openCodeModal ?
          <UploadCodeModal
            onSubmit={this.onCodeSubmit}
            onClose={this.handleOnClose}
          /> : null}

      </Dashboard>
    );
  }
}


function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment,
  };
}

export default connect(mapStateToProps)(OverviewNew);